import React from 'react'

import styles from './AuthRow.module.scss'

const AuthRow = ({ children }) => {
  return <section className={styles.row}>{children}</section>
}

export default AuthRow
